import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { trigger, state, transition, animate, style } from '@angular/animations';
import { MatDialog } from '@angular/material';
import { Paginate } from 'src/app/core/class/paginate';
import { CdkDetailRowDirective } from 'src/app/shared/directive/cdk-detail-row.directive';
import { NotifyService } from 'src/app/core/services/notify.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { NotifyDataSource, Notify } from 'src/app/core/class/notify';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { ToastrService } from 'ngx-toastr';
import { Message } from 'src/app/core/class/message';
import { EnumNotificationType } from 'src/app/core/constants/notification';
import { Router } from '@angular/router';


@Component({
  selector: 'app-notify',
  templateUrl: './notify.component.html',
  styleUrls: ['./notify.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('void', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('*', style({ height: '*', visibility: 'visible' })),
      transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class NotifyComponent implements OnInit, OnDestroy {
  paginate: Paginate;
  dataSource: NotifyDataSource;
  displayedColumns: string[] = ['STT', 'description', 'symbol'];
  expandedElement: NotifyElement | null;
  @Input() singleChildRowDetail: boolean;
  openedRow: CdkDetailRowDirective;
  viewDocumentQueryParams: {};
  public goFrom = '';
  EnumNotificationType = EnumNotificationType;
  userType: any = localStorage.getItem('userType') || null

  constructor(
    private notifyService: NotifyService,
    private notificationService: NotificationService,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private message: Message,
    private router: Router
  ) {
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };
  }

  ngOnInit() {
    this.dataSource = new NotifyDataSource();
    this.notificationService.subscribeErrorService();
    this.loadData();
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
  }

  /**
   * Call service to get Data for table
   */
  public loadData(page: number = 0, pageSize: number = 10) {
    this.notifyService.getNotifyList({ page, pageSize }).subscribe(rs => {
      if (rs && rs.data != null && rs.data.currentPage != null && rs.data.pageSize != null
        && rs.data.totalRow != null && rs.data.totalRow != null) {
        this.paginate = {
          currentPage: rs.data.currentPage,
          pageSize: rs.data.pageSize,
          totalRow: rs.data.totalRow,
          totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
          totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
          no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
        };
        let stt = this.paginate.pageSize * this.paginate.currentPage + 1;
        rs.data.dataRow.forEach(element => {
          element['STT'] = stt++;
        });
        this.dataSource.setData(rs.data.dataRow);
      }
    });
  }

  /**
   * On click button delete notify
   */
  deleteNotify(id: any) {
    const dialogRef = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.message.getMessage('messages.confirm_delete_notify')
    });
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        // this.notifyService.updateStatus(id).subscribe();
        this.notifyService.deleteNotify(id).subscribe(
          () => {
            this.toastr.success(this.message.getMessage('messages.delete_success'));
            if (this.paginate.totalRow % this.paginate.pageSize === 1) {
              if (this.paginate.currentPage - 1 < 0) {
                this.paginate.currentPage = 0;
              } else {
                this.paginate.currentPage = this.paginate.currentPage - 1;
              }
            }
            this.loadData(this.paginate.currentPage, this.paginate.pageSize);
          }
        );
      }
    });
  }

  getStringFromHtml(text) {
    const html = text;
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  }

  /**
   * Change arrow icon
   */
  onToggleChange(cdkDetailRow: CdkDetailRowDirective, row): void {
    if (this.singleChildRowDetail && this.openedRow && this.openedRow.expended) {
      this.openedRow.toggle();
    }

    if (!row.close) {
      row.close = true;
    } else {
      row.close = false;
    }
    this.openedRow = cdkDetailRow.expended ? cdkDetailRow : undefined;
  }

  /**
   * Change arrow icon
   */
  onChangPage(cdkDetailRow: CdkDetailRowDirective, row): void {

  }

  /**
   * Count record to show
   */
  private counter(index: number, from: number): any {
    return new Array(index).fill(0).map((x, i) => i + from);
  }

  /**
   * Update status notify
   */
  updateStatus(id: any, status: any) {
    if (status != 0) {
      return;
    } else {
      this.dataSource.data.value.forEach(notify => {
        if (notify.id == id) {
          notify.status = true;
        }
      });
      this.notifyService.updateStatus(id).subscribe();
    }
  }

  getContent(notify) {
    return this.notifyService.getContent(notify);
  }

  /**
   * Get condition to get data
   */
  private getFilterCondition(page: number, pageSize: number) {
    const filterCondition = {
      page,
      pageSize,
    };
    return filterCondition;
  }

  private isReciever(notify) {
    // switch (notify.notitficationType) {
    //   case 2:
    //   case 4:
    //   case 9:
    //   case 10:
    //     return true;
    //   default:
    //     return false;
    // }
    // return notify.notitficationType == 2 || notify.notitficationType == 4 || notify.notitficationType == 9 || notify.notitficationType == 10;

    //set goFrom to queryParams
    if (notify.notitficationType) {
      switch (notify.notitficationType) {
        case 15:
          this.goFrom = 'waitSign';
          break;
        case 24:
          this.goFrom = 'waitSign';
          break;
        case 25:
          this.goFrom = 'waitSign';
          break;
        case 34:
          this.goFrom = 'waitSign';
          break;

        case 16:
          this.goFrom = 'waitApprove';
          break;
        case 32:
          this.goFrom = 'waitApprove';
          break;
        case 33:
          this.goFrom = 'waitApprove';
          break;

        case 23:
          this.goFrom = 'waitInitial';
          break;

        case 18:
          this.goFrom = 'mine';
          break;
        case 19:
          this.goFrom = 'mine';
          break;
        case 20:
          this.goFrom = 'mine';
          break;
        case 21:
          this.goFrom = 'mine';
          break;
        case 22:
          this.goFrom = 'mine';
          break;
        case 36:
          this.goFrom = 'mine';
          break;

        case 17:
          this.goFrom = 'receive';
          break;
        case 26:
          this.goFrom = 'receive';
          break;
        case 27:
          this.goFrom = 'receive';
          break;
        case 29:
          this.goFrom = 'receive';
          break;
        case 30:
          this.goFrom = 'receive';
          break;
        case 31:
          this.goFrom = 'receive';
          break;
        case 35:
          this.goFrom = 'receive';
          break;
        case 37:
          this.goFrom = 'receive';
          break;
        case 38:
          this.goFrom = 'receive';
          break;
        case 40:
          this.goFrom = 'mineReceive';
          break;
        case 95:
          this.goFrom = 'negotiate';
          break;
        case 96:
          this.goFrom = 'negotiate';
          break;
        case 97:
          this.goFrom = 'negotiate';
          break;
        case 98:
          this.goFrom = 'share';
          break;
        case 103:
          if(this.userType == '5'){
            this.goFrom = 'waitSign';
          } else if(this.userType == '3') {
            this.goFrom = 'receive'
          } else {
            this.goFrom = 'enterprise'
          }
          break;
        case 107:
          break;
        case 114:
          this.goFrom = 'viewDigital';
          break;
        case 115:
          this.goFrom = 'waitSignMoha';
          break;
        case 116:
          this.goFrom = 'waitSignDigital';
          break;
        case 117:
          this.goFrom = 'waitApproveDigital';
          break;
        case 118:
          this.goFrom = 'waitSignDigital';
          break;
        case 119:
          this.goFrom = 'waitApproveDigital';
          break;
        default:
          break;
      }
    } else {
      this.goFrom = '';
    }

    return this.goFrom;
  }

  viewDocument(notify: Notify) {
    this.updateStatus(notify.id, notify.status);
    switch(notify.notitficationType) {
      case EnumNotificationType.CREATE_CONTRACT_LOT: {
        if(notify.contractLotType && notify.contractLotType === 'CONTRACT_MOHA' ){
          this.router.navigateByUrl('/home-enterprise/contract-lot-moha/' + notify.contractLotId);
        } else if(notify.contractLotType && notify.contractLotType === 'CONTRACT_MOHA_STANDARDIZED' ){
          this.router.navigateByUrl('/home-enterprise/contract-lot-standardized/' + notify.contractLotId);
        } else {
          this.router.navigateByUrl('/home-enterprise/contract-lot/' + notify.contractLotId);
        }
        break;
      }

      case EnumNotificationType.CREATE_CONTRACT_LOT_DIGITAL: {
        this.router.navigateByUrl('/home-enterprise/contract-digital-add-lot/add-lot/' + notify.contractLotId);
        break;
      }
      case EnumNotificationType.IMPORT_USER_FILE: {
        this.router.navigateByUrl('/home-enterprise/import-user/' + notify.objectId);
        break;
      }
      case EnumNotificationType.IMPORT_CUSTOMER_FILE: {
        this.router.navigateByUrl('/home-enterprise/import-customer/' + notify.objectId);
        break;
      }
      case EnumNotificationType.CONTRACT_PERSONAL_CREATE_ERROR:
      case EnumNotificationType.CONTRACT_PERSONAL_CREATE: {
        this.router.navigate(['/home-enterprise/contract-personal-create/analysis-report/'])
        break;
      }
      case EnumNotificationType.REPORT_USER_ERROR:
      case EnumNotificationType.REPORT_USER_SUCCESS: {
        this.router.navigate(['/home-enterprise/contract-user-report/analysis-report/'])
        break;
      }
      case EnumNotificationType.CONTRACT_ENTERPRISE_CREATE_ERROR:
      case EnumNotificationType.CONTRACT_ENTERPRISE_CREATE: {
        this.router.navigate(['/home-enterprise/contract-enterprise-create/analysis-report/'])
        break;
      }
      case EnumNotificationType.CONTRACT_ENTERPRISE_RECEIVE_ERROR:
      case EnumNotificationType.CONTRACT_ENTERPRISE_RECEIVE: {
        this.router.navigate(['/home-enterprise/contract-enterprise-receive/analysis-report/'])
        break;
      }
      case EnumNotificationType.TOTAL_CONTRACT_REPORT_ERROR:
      case EnumNotificationType.TOTAL_CONTRACT_REPORT: {
        this.router.navigate(['/home-enterprise/total-contract-report/analysis-report/'])
        break;
      }
      case EnumNotificationType.SMS_QUANTITY_REPORT_ERROR:
      case EnumNotificationType.SMS_QUANTITY_REPORT: {
        this.router.navigate(['/home-enterprise/sms-quantity-report/analysis-report/'])
        break;
      }
      case EnumNotificationType.SMS_MONEY_REPORT_ERROR:
      case EnumNotificationType.SMS_MONEY_REPORT: {
        this.router.navigate(['/home-enterprise/sms-money-report/analysis-report/'])
        break;
      }
      case EnumNotificationType.SIGN_MULTI_CANCEL:
      case EnumNotificationType.SIGN_WAIT:
      case EnumNotificationType.SIGN_MULTI_SUCCESS: {
        localStorage.setItem("notifiData", JSON.stringify(notify));
        localStorage.setItem("notitficationTypeSign",JSON.stringify(notify.notitficationType));
        this.router.navigate(['/home-enterprise/sign-batch-result/']);
        break;
      }
      case EnumNotificationType.SIGN_MULTI_FLOW_SUCCESS:
      case EnumNotificationType.SIGN_MULTI_FLOW_STOP:
      case EnumNotificationType.CANCEL_FLOW_SUCCESS:
      case EnumNotificationType.CANCEL_FLOW_CANCEL:
      case EnumNotificationType.DELETE_MULTI_FLOW_SUCCESS:
      case EnumNotificationType.DELETE_MULTI_FLOW_STOP:
      case EnumNotificationType.CONFIRM_FLOW_CANCEL:
      case EnumNotificationType.CONFIRM_FLOW_SUCCESS: {
        localStorage.setItem("notitficationTypeSign",JSON.stringify(notify.notitficationType));
        localStorage.setItem("notifiData", JSON.stringify(notify));
        this.router.navigate(['/home-enterprise/view-multiple-sign-flow/']);
        break;
      }
      case EnumNotificationType.CERTIFICATE_MONEY_SUCCESS:
      case EnumNotificationType.CERTIFICATE_MONEY_ERROR: {
        this.router.navigate(['/home-enterprise/certificate-money-report/analysis-report/'])
        break;
      }
      case EnumNotificationType.TIMESTAMP_QUANTITY_SUCCESS:
      case EnumNotificationType.TIMESTAMP_QUANTITY_ERROR: {
        this.router.navigate(['/home-enterprise/timestamp-quantity-report/analysis-report/'])
        break;
      }
      case EnumNotificationType.EXPORT_CUSTOMER_SUCCESS:
      case EnumNotificationType.EXPORT_CUSTOMER_ERROR: {
        this.router.navigate(['/home-enterprise/export-data-customer'])
        break;
      }
      case EnumNotificationType.DONE_INITIAL_WAIT_APPROVE:
      case EnumNotificationType.DONE_INITIAL_WAIT_APPROVE_CUSTOMER:
      case EnumNotificationType.DONE_SIGN_APPROVE:
      case EnumNotificationType.DONE_SIGN_APPROVE_CUSTOMER: {
        this.router.navigate(['/home-enterprise/view-document/' + notify.contractId], {
          queryParams: {
            page: this.paginate.currentPage,
            pageSize: this.paginate.pageSize,
            goFrom: this.isReciever(notify),
            routeLink: 'home-enterprise/notify/',
          }
        });
        break;
      }
      case EnumNotificationType.VIEW_DOCUMENT_MOHA_DIGITAL: {
        this.router.navigate(['/home-enterprise/contract-digitzation-moha/' + notify.contractId + '/view'], {
          queryParams: {
            page: this.paginate.currentPage,
            pageSize: this.paginate.pageSize,
            goFrom: this.isReciever(notify),
            routeLink: 'home-enterprise/notify/',
          }
        });
        break;
      }
      case EnumNotificationType.NEED_APPROVE: {
        this.router.navigate(['/home-enterprise/sign-confirm-document/' + notify.contractId], {
          queryParams: {
            page: this.paginate.currentPage,
            pageSize: this.paginate.pageSize,
            goFrom: this.isReciever(notify),
            routeLink: 'home-enterprise/notify/',
            needSign: true
          }
        });
        break;
      }
      case EnumNotificationType.APPROVE_MULTI_SUCCESS: {
        localStorage.setItem("notifiData", JSON.stringify(notify))
        this.router.navigate(['/home-enterprise/approve-batch-result/']);
        break;
      }
      case EnumNotificationType.APPROVE_MULTI_CANCEL: {
        localStorage.setItem("notifiData", JSON.stringify(notify))
        this.router.navigate(['/home-enterprise/approve-batch-result/']);
        break;
      }
      case EnumNotificationType.DECLINE_MULTI_SUCCESS: {
        localStorage.setItem("notifiData", JSON.stringify(notify))
        this.router.navigate(['/home-enterprise/decline-approval-batch-result/']);
        break;
      }
      case EnumNotificationType.DECLINE_MULTI_CANCEL: {
        localStorage.setItem("notifiData", JSON.stringify(notify))
        this.router.navigate(['/home-enterprise/decline-approval-batch-result/']);
        break;
      }
      case EnumNotificationType.DIGITAL: {
        this.router.navigate(['/home-enterprise/digital-business/' + notify.contractId +'/view']);
        break;
      }
      case EnumNotificationType.ADD_NEW_NEGOTIATE_COMMENT: {
        this.router.navigate([this.getDocumentDetailRoute(notify)], {
          queryParams: {
            page: this.paginate.currentPage,
            pageSize: this.paginate.pageSize,
            goFrom: this.getNotificationGoFrom(notify),
            routeLink: 'home-enterprise/notify/',
          }
        });
        break;
      }
      case EnumNotificationType.CREATE_NEGOTIATE_CONTRACT: {
        this.router.navigate([this.getDocumentDetailRoute(notify)], {
          queryParams: {
            page: this.paginate.currentPage,
            pageSize: this.paginate.pageSize,
            goFrom: this.getNotificationGoFrom(notify),
            routeLink: 'home-enterprise/notify/',
          }
        });
        break;
      }
      case EnumNotificationType.UPDATE_NEGOTIATE_CONTRACT: {
        this.router.navigate([this.getDocumentDetailRoute(notify)], {
          queryParams: {
            page: this.paginate.currentPage,
            pageSize: this.paginate.pageSize,
            goFrom: this.getNotificationGoFrom(notify),
            routeLink: 'home-enterprise/notify/',
          }
        });
        break;
      }
      case EnumNotificationType.CONTRACT_SHARE_PARTNER: {
        this.router.navigate([this.getDocumentDetailRoute(notify)], {
          queryParams: {
            page: this.paginate.currentPage,
            pageSize: this.paginate.pageSize,
            goFrom: this.getNotificationGoFrom(notify),
            routeLink: 'home-enterprise/notify/',
          }
        });
        break;
      }
      case EnumNotificationType.CONTRACT_LIQUIDATION_SUCCESS: {
        this.router.navigate([this.getDocumentDetailRoute(notify)], {
          queryParams: {
            page: this.paginate.currentPage,
            pageSize: this.paginate.pageSize,
            goFrom: this.getNotificationGoFrom(notify),
            routeLink: 'home-enterprise/notify/',
          }
        });
        break;
      }
      case EnumNotificationType.REPORT_PROCESSING_SUCCESS: {
        this.router.navigate(['/home-enterprise/contract-processing/analysis-report']);
        break;
      }
      case EnumNotificationType.REPORT_PROCESSING_ERROR: {
        this.router.navigate(['/home-enterprise/contract-processing/analysis-report']);
        break;
      }
      case EnumNotificationType.SIGN_MULTI_SUCCESS_DIGITAL:
      case EnumNotificationType.SIGN_MULTI_CANCEL_DIGITAL: {
        localStorage.setItem("notifiData", JSON.stringify(notify));
        localStorage.setItem("notitficationTypeSign",JSON.stringify(notify.notitficationType));
        this.router.navigate(['/home-enterprise/sign-digital-batch-result/']);
        break;
      }
      // case EnumNotificationType.REFUND_RESOURCE:
      //   break;
      default: {
        this.router.navigate([this.getDocumentDetailRoute(notify)], {
          queryParams: {
            page: this.paginate.currentPage,
            pageSize: this.paginate.pageSize,
            goFrom: this.getNotificationGoFrom(notify),
            routeLink: 'home-enterprise/notify/',
          }
        });
        break;
      }
    }
    if (notify.notitficationType != EnumNotificationType.RESET_PASSWORD && notify.notitficationType != EnumNotificationType.CREATE_ACCOUNT
      && notify.notitficationType != EnumNotificationType.APPROVE_MULTI_SUCCESS && notify.notitficationType != EnumNotificationType.SIGN_MULTI_CANCEL
      && notify.notitficationType != EnumNotificationType.DECLINE_MULTI_SUCCESS && notify.notitficationType != EnumNotificationType.DECLINE_MULTI_CANCEL
      && notify.notitficationType != EnumNotificationType.SIGN_MULTI_SUCCESS && notify.notitficationType != EnumNotificationType.SIGN_MULTI_CANCEL
      && notify.notitficationType != EnumNotificationType.CANCEL_SIGN_FLOW && notify.notitficationType != EnumNotificationType.CREATE_CONTRACT_LOT
      && notify.notitficationType != EnumNotificationType.IMPORT_USER_FILE && notify.notitficationType != EnumNotificationType.IMPORT_CUSTOMER_FILE
      && notify.notitficationType != EnumNotificationType.CONTRACT_PERSONAL_CREATE && notify.notitficationType != EnumNotificationType.CONTRACT_ENTERPRISE_CREATE
      && notify.notitficationType != EnumNotificationType.CONTRACT_ENTERPRISE_RECEIVE && notify.notitficationType != EnumNotificationType.TOTAL_CONTRACT_REPORT
      && notify.notitficationType != EnumNotificationType.SMS_QUANTITY_REPORT && notify.notitficationType != EnumNotificationType.SMS_MONEY_REPORT
      && notify.notitficationType != EnumNotificationType.CONTRACT_PERSONAL_CREATE_ERROR && notify.notitficationType != EnumNotificationType.CONTRACT_ENTERPRISE_CREATE_ERROR
      && notify.notitficationType != EnumNotificationType.CONTRACT_ENTERPRISE_RECEIVE_ERROR && notify.notitficationType != EnumNotificationType.TOTAL_CONTRACT_REPORT_ERROR
      && notify.notitficationType != EnumNotificationType.SMS_QUANTITY_REPORT_ERROR && notify.notitficationType != EnumNotificationType.SMS_MONEY_REPORT_ERROR
      && notify.notitficationType != EnumNotificationType.SIGN_MULTI_FLOW_SUCCESS && notify.notitficationType != EnumNotificationType.SIGN_MULTI_FLOW_STOP
      && notify.notitficationType != EnumNotificationType.DELETE_MULTI_FLOW_SUCCESS && notify.notitficationType != EnumNotificationType.DELETE_MULTI_FLOW_STOP
      && notify.notitficationType != EnumNotificationType.CERTIFICATE_MONEY_SUCCESS && notify.notitficationType != EnumNotificationType.CERTIFICATE_MONEY_ERROR
      && notify.notitficationType != EnumNotificationType.TIMESTAMP_QUANTITY_SUCCESS && notify.notitficationType != EnumNotificationType.TIMESTAMP_QUANTITY_ERROR
      && notify.notitficationType != EnumNotificationType.EXPORT_CUSTOMER_SUCCESS && notify.notitficationType != EnumNotificationType.EXPORT_CUSTOMER_ERROR
      && notify.notitficationType != EnumNotificationType.DONE_INITIAL_WAIT_APPROVE && notify.notitficationType != EnumNotificationType.DONE_INITIAL_WAIT_APPROVE_CUSTOMER
      && notify.notitficationType != EnumNotificationType.NEED_APPROVE && notify.notitficationType != EnumNotificationType.DONE_SIGN_APPROVE
      && notify.notitficationType != EnumNotificationType.DONE_SIGN_APPROVE_CUSTOMER && notify.notitficationType != EnumNotificationType.CANCEL_SIGN_APPROVE_CUSTOMER
      && notify.notitficationType != EnumNotificationType.NOTIFICATION_TRANSFER_MONEY_STA_TO_SMS_SUCCESS && notify.notitficationType != EnumNotificationType.NOTIFICATION_TRANSFER_MONEY_SMS_TO_STA_SUCCESS
      && notify.notitficationType != EnumNotificationType.DIGITAL && notify.notitficationType != EnumNotificationType.SIGN_WAIT && notify.notitficationType !=EnumNotificationType.REPORT_USER_ERROR
      && notify.notitficationType !=EnumNotificationType.REPORT_USER_SUCCESS && notify.notitficationType !=EnumNotificationType.CONFIRM_FLOW_CANCEL && notify.notitficationType !=EnumNotificationType.CONFIRM_FLOW_SUCCESS
      && notify.notitficationType !=EnumNotificationType.CANCEL_FLOW_SUCCESS && notify.notitficationType !=EnumNotificationType.CANCEL_FLOW_CANCEL && notify.notitficationType !=EnumNotificationType.REPORT_PROCESSING_ERROR
      && notify.notitficationType !=EnumNotificationType.REPORT_PROCESSING_SUCCESS && notify.notitficationType !=EnumNotificationType.SIGN_MULTI_SUCCESS_DIGITAL  && notify.notitficationType !=EnumNotificationType.SIGN_MULTI_CANCEL_DIGITAL
      && notify.notitficationType !=EnumNotificationType.CREATE_CONTRACT_LOT_DIGITAL
      )
    {
      this.router.navigate([this.getDocumentDetailRoute(notify)], {
        queryParams: {
          goFrom: this.getNotificationGoFrom(notify)
        }
      });
    }

  }

  private getDocumentDetailRoute(notify: Notify) {
    if (this.isDigitalEmploymentNotification(notify)) {
      if (this.goFrom === 'viewDigital') {
        return '/home-enterprise/contract-digitzation-moha/' + notify.contractId + '/view';
      }
      return '/home-enterprise/view-document-moha-digital/' + notify.contractId;
    }
    if (notify.isEmploymentContract) {
      return '/home-enterprise/view-document-moha/' + notify.contractId;
    }
    return '/home-enterprise/view-document/' + notify.contractId;
  }

  private getNotificationGoFrom(notify: Notify) {
    const goFrom = this.isReciever(notify);

    if (!this.isDigitalEmploymentNotification(notify)) {
      return goFrom;
    }

    // if (goFrom === 'waitSign') {
    //   this.goFrom = 'waitSignDigital';
    // } else if (goFrom === 'waitApprove') {
    //   this.goFrom = 'waitApproveDigital';
    // } else if (goFrom === 'mine') {
    //   this.goFrom = 'digitalMyEmployment';
    // }

    return this.goFrom;
  }

  private isDigitalEmploymentNotification(notify: Notify) {
    return notify.isDigitalEmploymentContract;
  }
}
export interface NotifyElement {
  requestBy: string;
  status: number;
  content: string;
  notitficationType: string;
  createdTime: string;
  receivedBy: string;
  title: string;
}
